// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"7b233b42","489":"6c589a1e","787":"defd8950"}[chunkId] + ".chunk.js";
};